import { useEffect, useState } from 'react'
import { Route, NavLink } from 'react-router-dom'
import { useRouter } from "../../hooks/router";
import { translateWord, decrypt } from "../Util/util";
import { autoSignInSubUser } from "../../server/requests";

import EmailCheck from './EmailCheck';

// import Login from './login'
import SignUp from "./SignUp/SignUp";

import './Auth.scss'
import Login from './login';
import ResetPassword from './ResetPassword';
import ForgotPassword from './ForgotPassword';
import VerifyCode from './VerifyCode';
import MessageVerify from './MessageVerify';

// import logoPopUp from "./images/LOGO.png"
import MailVerification from './MailVerification';
import Loading from '../Loading/Loading';
// import MessageSignUp from './MessageSignUp';


export default function Auth({ configs, isGuest, setIsGuest }) {
    const router = useRouter()
    const token = decrypt('token', localStorage.getItem("token"))

    const [popUpTitles, setPopUpTitles] = useState('Login')
    const [logo, setLogo] = useState('')
    const [signingIn, setSigningIn] = useState(!!sessionStorage.getItem('auto_signing_in'))

    useEffect(() => {
        if (token && !localStorage.getItem('showLogin')) {
            if (localStorage.getItem('user')) router.push('/')
            else {
                setSigningIn(true)
                autoSignInSubUser(router, null, () => setSigningIn(false))
            }
        }

        setLogo(localStorage.getItem('logo'))

    }, [])

    if (signingIn) return <Loading />

    return (
        <div className="conteiner">
            <div className='pup_up_auth' style={{ backgroundImage: `url('${localStorage.getItem('background_image')}')` }}>
                <div className="pup_up_login">
                    <div className={'main_auth'}>
                        {router.pathname !== '/auth/sign-up' ?
                            <h1 className={'title_pop_up'}>{translateWord(popUpTitles.toLowerCase(), popUpTitles)}</h1>
                            : null}
                        <div className="login_with_pages">

                            <Route exact path={'/auth'}>
                                <EmailCheck configs={configs} setPopUpTitles={setPopUpTitles} setIsGuest={setIsGuest} />
                            </Route>

                            <Route exact path={'/auth/sign-in'}>
                                <Login configs={configs} setPopUpTitles={setPopUpTitles} setIsGuest={setIsGuest} />
                            </Route>

                            <Route path={'/auth/forgot-password'}>
                                <ForgotPassword setPopUpTitles={setPopUpTitles} />
                            </Route>

                            <Route path={'/auth/reset-password'}>
                                <ResetPassword setPopUpTitles={setPopUpTitles} />
                            </Route>

                            <Route path={'/auth/sign-up'}>
                                <SignUp />
                            </Route>

                            <Route path={'/auth/verify-code'}>
                                <VerifyCode setPopUpTitles={setPopUpTitles} />
                            </Route>

                            <Route path={'/auth/message'}>
                                <MessageVerify setPopUpTitles={setPopUpTitles} />
                            </Route>
                            <Route path={'/auth/mail-verification'}>
                                <MailVerification setPopUpTitles={setPopUpTitles} />
                            </Route>
                            {/* 
                           
                         
                            <Route path={'/auth/registered'}>
                                <MessageSignUp setPopUpTitles={setPopUpTitles} title={'Thank you for registering!'} />
                            </Route>
                            <Route path={'/auth/mail-verify'}>
                                <MessageSignUp setPopUpTitles={setPopUpTitles} title={'mail'} />
                            </Route> 

                            */}
                        </div>
                    </div>

                    <div className="logo_in_pop_up">
                        <img src={localStorage.getItem('logo')} alt="" />
                    </div>
                </div>
            </div>
        </div>

    )
}